import getCurrentHourOption from '../select-options/get-current-hour-option';

const getLoadGaugeRows = (
  slots: number[],
  minBookTime: number,
  openFrom: number,
  openTo: number,
  date?: string[],
  start?: string,
  end?: string
): number[][] => {
  setCloseHoursSlots(slots, openFrom, openTo);
  setPastHoursSlots(slots, date);
  changeSlotsByMinimumBooking(slots, minBookTime / 0.25);
  setSelectedAllocSlots(slots, start, end);
  const rows: number[][] = [];

  for (let i = 0; i < slots.length; i = i + 2) {
    rows[i / 2] = [slots[i], slots[i + 1]];
  }

  return rows;
};

const setCloseHoursSlots = (
  slots: number[],
  openFrom: number,
  openTo: number
) => {
  for (let i = 0; i <= 95; i++) {
    if (i < openFrom * 4 || i >= openTo * 4) {
      slots[i] = 1;
    }
  }
};

const setPastHoursSlots = (slots: number[], date?: string[]) => {
  if (
    date?.length &&
    new Date(date[0]).toDateString() === new Date().toDateString()
  ) {
    const currentHourOption = getCurrentHourOption();
    for (let i = 0; i <= currentHourOption / 0.25; i++) {
      slots[i] = 1;
    }
  }
};

const setSelectedAllocSlots = (
  slots: number[],
  start?: string,
  end?: string
) => {
  if (start && end) {
    const startIndex = +start / 0.25;
    const endIndex = +end / 0.25;
    for (let i = startIndex; i < endIndex; i++) {
      slots[i] = 2;
    }
  }
};
const changeSlotsByMinimumBooking = (slots: number[], minBooking: number) => {
  let i = 0;
  let startIndex;
  let endIndex;
  while (i < slots.length) {
    if (!startIndex && slots[i] === 0) {
      startIndex = i;
    }

    if (startIndex && slots[i] === 1) {
      endIndex = i;
    }

    if (startIndex && endIndex && endIndex - startIndex < minBooking) {
      for (let i = startIndex; i < endIndex; i++) {
        slots[i] = 1;
      }
      startIndex = undefined;
      endIndex = undefined;
    }
    i++;
  }
};
export default getLoadGaugeRows;
